import { render } from "./TabLink.vue?vue&type=template&id=238c33e6"
import script from "./TabLink.vue?vue&type=script&lang=js"
export * from "./TabLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__